var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ADD_TENANT_ORDER_OPERATOR from 'api/mutations/ADD_TENANT_ORDER_OPERATOR';
import ARCHIVE_TENANT_ORDER_OPERATOR from 'api/mutations/ARCHIVE_TENANT_ORDER_OPERATOR';
import REMOVE_TENANT_ORDER_OPERATOR from 'api/mutations/REMOVE_TENANT_ORDER_OPERATOR';
import RETRIEVE_TENANT_ORDER_OPERATOR from 'api/mutations/RETRIEVE_TENANT_ORDER_OPERATOR';
import UPDATE_TENANT_ORDER_OPERATOR from 'api/mutations/UPDATE_TENANT_ORDER_OPERATOR';
import GET_CURRENT_TENANT_ORDER_OPERATORS from 'api/queries/GET_CURRENT_TENANT_ORDER_OPERATORS';
import client from '../api/environment';
const initialState = {
    items: [],
    status: {
        fetch: 'idle',
        add: 'idle',
        update: 'idle',
        remove: 'idle',
        other: 'idle',
    },
    errors: {
        fetch: null,
        add: null,
        update: null,
        remove: null,
        other: null,
    },
    pageInfo: {
        hasNextPage: true,
        endCursor: null,
    },
    filters: {
        name: null,
        statusId: '',
    },
};
export const fetchOrderOperators = createAsyncThunk('orderOperators/fetchOrderOperators', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { getState, rejectWithValue }) {
    const state = getState();
    const { filters, pageInfo } = state.orderOperators;
    try {
        const response = yield client.query({
            query: GET_CURRENT_TENANT_ORDER_OPERATORS,
            variables: {
                name: filters.name || null,
                statusId: filters.statusId || null,
                first: 20,
                after: pageInfo.endCursor,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.me.currentTenant.orderOperators;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addOrderOperator = createAsyncThunk('orderOperators/addOrderOperator', (variables_1, _a) => __awaiter(void 0, [variables_1, _a], void 0, function* (variables, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: ADD_TENANT_ORDER_OPERATOR,
            variables,
        });
        return response.data.addOrderOperator.orderOperator;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateOrderOperator = createAsyncThunk('orderOperators/updateOrderOperator', (variables_1, _a) => __awaiter(void 0, [variables_1, _a], void 0, function* (variables, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: UPDATE_TENANT_ORDER_OPERATOR,
            variables,
        });
        return response.data.updateOrderOperator.orderOperator;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const archiveOrderOperator = createAsyncThunk('orderOperators/archiveOrderOperator', (orderOperatorId_1, _a) => __awaiter(void 0, [orderOperatorId_1, _a], void 0, function* (orderOperatorId, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: ARCHIVE_TENANT_ORDER_OPERATOR,
            variables: { orderOperatorId },
        });
        return response.data.archiveOrderOperator.orderOperator;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const retrieveOrderOperator = createAsyncThunk('orderOperators/retrieveOrderOperator', (orderOperatorId_1, _a) => __awaiter(void 0, [orderOperatorId_1, _a], void 0, function* (orderOperatorId, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: RETRIEVE_TENANT_ORDER_OPERATOR,
            variables: { orderOperatorId },
        });
        return response.data.retrieveOrderOperator.orderOperator;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const removeOrderOperator = createAsyncThunk('orderOperators/removeOrderOperator', (orderOperatorId_1, _a) => __awaiter(void 0, [orderOperatorId_1, _a], void 0, function* (orderOperatorId, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: REMOVE_TENANT_ORDER_OPERATOR,
            variables: { orderOperatorId },
        });
        if (response.data.removeOrderOperator.removed) {
            return orderOperatorId;
        }
        return rejectWithValue('Remove failed');
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const orderOperatorsSlice = createSlice({
    name: 'orderOperators',
    initialState,
    reducers: {
        setFilter(state, action) {
            const { filterName, value } = action.payload;
            state.filters[filterName] = value;
        },
        resetFilters(state) {
            state.filters = {
                name: null,
                statusId: null,
            };
        },
        resetOrderOperators(state) {
            state.items = [];
            state.pageInfo = { hasNextPage: true, endCursor: null };
            state.status.fetch = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrderOperators.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchOrderOperators.fulfilled, (state, action) => {
            var _a;
            const newOrderOperators = action.payload.edges.map((edge) => edge.node);
            const uniqueOrderOperators = newOrderOperators.filter((newOrderOperator) => !state.items.some((existingOrderOperator) => existingOrderOperator.id === newOrderOperator.id));
            state.items = [...state.items, ...uniqueOrderOperators];
            state.pageInfo = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.pageInfo;
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchOrderOperators.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch = action.error.message || 'Error fetching order operators';
        })
            .addCase(addOrderOperator.pending, (state) => {
            state.status.add = 'loading';
            state.errors.add = null;
        })
            .addCase(addOrderOperator.fulfilled, (state, action) => {
            state.items = [action.payload, ...state.items];
            state.status.add = 'succeeded';
        })
            .addCase(addOrderOperator.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.payload;
        })
            .addCase(updateOrderOperator.pending, (state) => {
            state.status.update = 'loading';
            state.errors.update = null;
        })
            .addCase(updateOrderOperator.fulfilled, (state, action) => {
            const updated = action.payload;
            const itemIndex = state.items.findIndex((item) => item.id === updated.id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), updated);
            }
            state.status.update = 'succeeded';
        })
            .addCase(updateOrderOperator.rejected, (state, action) => {
            state.status.update = 'failed';
            state.errors.update = action.payload;
        })
            .addCase(archiveOrderOperator.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(archiveOrderOperator.fulfilled, (state, action) => {
            const updated = action.payload;
            const itemIndex = state.items.findIndex((item) => item.id === updated.id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), updated);
            }
            state.status.other = 'succeeded';
        })
            .addCase(archiveOrderOperator.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            .addCase(retrieveOrderOperator.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(retrieveOrderOperator.fulfilled, (state, action) => {
            const updated = action.payload;
            const itemIndex = state.items.findIndex((item) => item.id === updated.id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), updated);
            }
            state.status.other = 'succeeded';
        })
            .addCase(retrieveOrderOperator.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            .addCase(removeOrderOperator.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(removeOrderOperator.fulfilled, (state, action) => {
            state.items = state.items.filter((item) => item.id !== action.payload);
            state.status.remove = 'succeeded';
        })
            .addCase(removeOrderOperator.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        });
    },
});
export const { setFilter, resetFilters, resetOrderOperators } = orderOperatorsSlice.actions;
export const selectOrderOperatorsStatus = (state) => state.orderOperators.status;
export const selectOrderOperatorsPageInfo = (state) => state.orderOperators.pageInfo;
export default orderOperatorsSlice.reducer;
